import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";
import AgendaTable from "@/components/AgendaTable";

const GROUPS = [
  { key: "kelembagaan", label: "KELEMBAGAAN & KERJA SAMA" },
  { key: "akademik", label: "AKADEMIK & RISBANG" },
  { key: "kemahasiswaan", label: "KEMAHASISWAAN" },
  { key: "sdpt", label: "SUMBER DAYA PERGURUAN TINGGI" },
  { key: "sistem-informasi", label: "SISTEM INFORMASI" },
  { key: "hukum-kepegawaian", label: "HUKUM, KEPEGAWAIAN & TATA LAKSANA" },
  { key: "keuangan", label: "KEUANGAN" },
  { key: "tata-usaha", label: "TATA USAHA" },
  { key: "ppid", label: "PPID" },
  { key: "spi", label: "SPI" },
  { key: "rbzi", label: "REFORMASI BIROKRASI DAN ZONA INTEGRITAS" },
];

const SECTIONS = [
  { id: "agenda", label: "Agenda Kegiatan" },
  { id: "tautan", label: "Pengumuman Kegiatan" },
];

export default function Pengumuman() {
  const [active, setActive] = useState("agenda");
  const [openGroup, setOpenGroup] = useState(null);
  const [agenda, setAgenda] = useState(null);

  useEffect(() => {
    api("/api/agenda")
      .then(setAgenda)
      .catch(() => setAgenda({}));
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Pusat Informasi — Pengumuman
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Pengumuman
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <div className="mt-14 grid gap-10 lg:grid-cols-[300px_1fr] lg:gap-16">
          <Reveal className="min-w-0">
            <nav
              data-testid="pengumuman-sidebar"
              aria-label="Menu pengumuman"
              className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:gap-1.5 lg:overflow-visible lg:border-r lg:border-slate-200 lg:pb-0"
            >
              {SECTIONS.map((s) => {
                const isActive = active === s.id;
                return (
                  <button
                    key={s.id}
                    data-testid={`pengumuman-menu-${s.id}`}
                    onClick={() => setActive(s.id)}
                    className={`whitespace-nowrap rounded-full px-4 py-3 text-left text-[13px] font-semibold transition-colors duration-200 lg:rounded-2xl lg:px-5 lg:py-3.5 ${isActive ? "bg-[#1479BF] text-white" : "bg-[#F3F7FB] text-slate-600 hover:text-[#1479BF]"}`}
                  >
                    {s.label}
                  </button>
                );
              })}
            </nav>
          </Reveal>

          <Reveal delay={0.1} className="min-w-0">
            {active === "agenda" ? (
              <div data-testid="panel-agenda" className="min-w-0">
                <h2 className="font-display text-2xl font-semibold leading-snug text-[#0B2440] md:text-3xl">
                  Informasi Pelaksanaan Program dan Kegiatan
                </h2>
                <div className="mt-8 overflow-hidden rounded-3xl border border-[#E3EBF3]">
                  {GROUPS.map((g, i) => {
                    const open = openGroup === i;
                    const entries = agenda?.[g.key];
                    return (
                      <div
                        key={g.key}
                        className="border-b border-[#E3EBF3] last:border-b-0"
                      >
                        <button
                          data-testid={`agenda-group-${i + 1}`}
                          aria-expanded={open}
                          onClick={() => setOpenGroup(open ? null : i)}
                          className={`flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[13px] font-semibold transition-colors duration-200 ${open ? "bg-[#EFF6FC] text-[#1479BF]" : "text-slate-600 hover:bg-[#F3F7FB] hover:text-[#1479BF]"}`}
                        >
                          <span className="min-w-0">{g.label}</span>
                          <span
                            aria-hidden="true"
                            className={`inline-block shrink-0 text-[10px] transition-transform duration-300 ${open ? "rotate-180" : ""}`}
                          >
                            ▾
                          </span>
                        </button>
                        <div
                          className={`grid transition-[grid-template-rows] duration-300 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
                        >
                          <div className="overflow-hidden">
                            <div className="border-t border-[#E3EBF3] bg-[#F3F7FB] px-5 py-5">
                              {entries == null ? (
                                <p className="text-sm text-slate-400">
                                  Memuat...
                                </p>
                              ) : entries.length === 0 ? (
                                <p
                                  data-testid={`agenda-content-${i + 1}`}
                                  className="text-sm leading-relaxed text-slate-500"
                                >
                                  Informasi Program dan Kegiatan akan segera
                                  diperbarui.
                                </p>
                              ) : (
                                <AgendaTable
                                  entries={entries}
                                  groupLabel={g.label}
                                  testId={`agenda-content-${i + 1}`}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div data-testid="panel-tautan" className="min-w-0">
                <p className="max-w-xl text-[15px] leading-relaxed text-slate-600 md:text-base">
                  Lihat pengumuman kegiatan di laman LLDIKTI Wilayah VII
                </p>
                <a
                  href="https://lldikti7.kemdiktisaintek.go.id/pengumuman"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="pengumuman-external-button"
                  className="mt-8 inline-flex items-center justify-center rounded-full bg-[#1479BF] px-7 py-3.5 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#0B2440]"
                >
                  BUKA PENGUMUMAN
                </a>
              </div>
            )}
          </Reveal>
        </div>
      </main>
      <Footer compact />
    </div>
  );
}
